import type { SVGProps } from 'react';

const IconAIEdit = ({ className, ...props }: { className?: string } & SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="17"
    height="17"
    viewBox="0 0 17 17"
    fill="none"
    className={className}
    {...props}
  >
    <g clip-path="url(#clip0_1_6)">
      <path
        d="M5 15.7143H7.79593L15.1352 8.37498C15.3188 8.1914 15.4644 7.97345 15.5638 7.73359C15.6632 7.49373 15.7143 7.23664 15.7143 6.97702C15.7143 6.71739 15.6632 6.46031 15.5638 6.22045C15.4644 5.98058 15.3188 5.76264 15.1352 5.57906C14.9516 5.39547 14.7337 5.24985 14.4938 5.15049C14.254 5.05114 13.9969 5 13.7373 5C13.4776 5 13.2206 5.05114 12.9807 5.15049C12.7408 5.24985 12.5229 5.39547 12.3393 5.57906L5 12.9184V15.7143Z"
        stroke="currentColor"
        strokeWidth="1.39796"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.6403 6.27804L14.4363 9.07396"
        stroke="currentColor"
        strokeWidth="1.39796"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4 9C4 7.93913 4.42143 6.92172 5.17157 6.17157C5.92172 5.42143 6.93913 5 8 5C6.93913 5 5.92172 4.57857 5.17157 3.82843C4.42143 3.07828 4 2.06087 4 1C4 2.06087 3.57857 3.07828 2.82843 3.82843C2.07828 4.57857 1.06087 5 0 5C1.06087 5 2.07828 5.42143 2.82843 6.17157C3.57857 6.92172 4 7.93913 4 9Z"
        stroke="currentColor"
        strokeWidth="1.07143"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_6">
        <rect
          width="17"
          height="17"
          fill="white"
        />
      </clipPath>
    </defs>
  </svg>
);

export default IconAIEdit;
